<div id="checkout" class="bg-gray-100 h-full overflow-y-auto">
  <button
    type="button"
    class="flex items-center bg-white rounded-xl py-2 px-4 text-gray-900 font-bold ml-10 my-5"
    (click)="restartTransaction()">
    <svg
      class="w-5 h-5 mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 19l-7-7 7-7"></path>
    </svg>
    Back
  </button>
  <div class="container mx-auto">
    <div class="relative flex flex-col justify-start mb-7 md:mb-5 text-center">
      <h1 class="self-start mb-1 md:mb-3 lg:mb-0 text-4xl">Your cart</h1>
    </div>
  </div>
  <div
    class="container mx-auto grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 gap-4 mb-10">
    @if (this.configurationService.configuration.upsells) {
      <div class="w-full max-w-2xl">
        <app-group-outing
          class="flex h-full"
          [transaction]="transaction()!"
          [upsellSelected]="upsellSelected"
          [totalTransactionSeats]="totalTransactionSeats"
          (changeUpsell)="onChangeUpsell($event)" />
      </div>
    }
    <div
      class="row-span-2 order-2 md:order-1 md:sticky self-start top-10 left-0">
      <div class="w-full max-w-2xl mb-4">
        <app-timer
          (transactionExpired)="onTransactionExpired()"
          [createdTime]="this.transaction()!.transaction.createdAt"></app-timer>
      </div>
      <div class="w-full max-w-2xl mb-4">
        <app-summary
          [transaction]="transaction()!"
          [totalTransactionSeats]="totalTransactionSeats"
          [upsellSelected]="upsellSelected"
          [rainoutValue]="rainoutValue"
          [isTicketFeeEnabled]="isTicketFeeEnabled()" />
      </div>
      <div class="w-full max-w-2xl">
        <app-rainout-info
          [transaction]="transaction()!"
          [totalTransactionSeats]="seats.length"
          [upsellSelected]="upsellSelected"
          (changeUpsell)="onChangeUpsell($event)"
          (rainoutChange)="onRainoutChange($event)" />
      </div>
      <div class="w-full max-w-2xl">
        <button
          data-cy="go-to-payment-button"
          class="bg-gray-900 disabled:bg-gray-600 disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform ml-auto btn-black"
          (click)="proceedToPayment()"
          [disabled]="
            configurationService.configuration.rainout &&
            rainoutValue === null &&
            eventDate - nowDate > deadlineInMilliseconds
          "
          [tooltip]="
            configurationService.configuration.rainout &&
            rainoutValue === null &&
            eventDate - nowDate > deadlineInMilliseconds
              ? 'Please select a Rainout Insurance option.'
              : ''
          "
          placement="top"
          triggers="pointerenter:pointerout">
          Proceed to Payment
          <span class="ml-4 pointer-events-none"
            ><img
              ngSrc="/assets/img/arrow-right-white-icon.svg"
              width="8"
              height="14"
              [priority]="false"
              alt="Arrow right icon"
          /></span>
        </button>
      </div>
    </div>
    <div class="w-full max-w-2xl order-1 md:order-2">
      <app-cart class="flex h-full" [transaction]="transaction()!" />
    </div>
  </div>
</div>
